// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// LIBRERIE ESTERNE
import Slider from "react-slick";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

// STILI X SLINK
import heroCarouselSyle from "../../../assets/jsStyle/heroCarouselStyle";

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = false /* Default a true se non specificato*/ }) => {

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    const carouselImages = [
        {src: "/assets/images/inHome/heroCarousel/c1.webp", alt: t('homePage.hero.carouselImage1Alt')},
        {src: "/assets/images/inHome/heroCarousel/c2.webp", alt: t('homePage.hero.carouselImage2Alt')},
        {src: "/assets/images/inHome/heroCarousel/c3.webp", alt: t('homePage.hero.carouselImage3Alt')},
    ]

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner">

            <Slider {...heroCarouselSyle} className="bg-overlay-black-10">
                {carouselImages.map((image, index) => (
                    <div key={index}>
                        <img src={image.src} alt={image.alt} className="carousel-image" />
                    </div>
                ))}
            </Slider>
            <div className="text-wrapper">
                <h3>{t('homePage.hero.subTitle')}</h3>
                <h1 className="title" dangerouslySetInnerHTML={{ __html: t('homePage.hero.title') as string }}></h1>
                <p dangerouslySetInnerHTML={{ __html: t('homePage.hero.para') as string }}></p>
                <Link to="/immobili" className="btn btn-primary">{t('homePage.hero.buttonText')}</Link>
                <img className="d-none d-md-block" src="/assets/images/inHome/bgDesign.svg" alt="bg-design"/>
            </div>

            { /* Attiva box a comparsa + form ricerca */}
            {false && (
                <div className="container-fluid">
                    <div className="text-wrapper">
                        <div className="row justify-content-center">
                            <div className="col-11">
                                {showSearchForm && <PropertySearchField searchData={{}} />}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Attiva l'indicatore di scroll */}
            {false && (
                <div className="scroll-indicator">
                    <span>scroll</span>
                    <div className="scroll-bar"></div>
                </div>
            )}
        </section>
    );
};

export default SubHeaderHome;